import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useOnFarmActionBlocked } from '../../../../hooks/useOnFarmActionBlocked';
import { REACT_APP_ON_FARM_ENABLED } from '../../../../constants/apiEndpoints';
import { ACCOUNT_PATHS, ON_FARM_PATHS } from '../../../../constants/routePaths';
import { NAVIGATION_LINK_CONSTANTS, PAGE_HEADER_CONSTANTS } from '../../../../constants/common';
import { DropDownSVG, InventorySVG } from '../../../svgs';

type InventoryLinksProps = {
  currentRoute: string[];
  showInventoryOptions: boolean;
  setShowInventoryOptions: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenNavBar: React.Dispatch<React.SetStateAction<boolean>>;
};

const InventoryLinks: FC<InventoryLinksProps> = ({
  currentRoute,
  showInventoryOptions,
  setShowInventoryOptions,
  setOpen,
  setOpenNavBar,
}) => {
  const [showOnFarmOptions, setShowOnFarmOptions] = useState<boolean>(false);
  const isOnFarmLocked = useOnFarmActionBlocked();
  const canTransact = !isOnFarmLocked;

  useEffect(() => {
    setShowOnFarmOptions(currentRoute.includes(ACCOUNT_PATHS.ON_FARM));
  }, [currentRoute]);

  const inventoryActive =
    currentRoute.includes(ACCOUNT_PATHS.INVENTORY) || (REACT_APP_ON_FARM_ENABLED && currentRoute.includes(ACCOUNT_PATHS.ON_FARM));

  const activeLinkClass = () => {
    return inventoryActive ? 'nav-link active' : 'nav-link';
  };

  const activeSubLinkClass = (path: string) => {
    return currentRoute.includes(path) ? 'nav-sub-link active' : 'nav-sub-link';
  };

  const isRsgInventoryActive = () =>
    currentRoute.includes(ACCOUNT_PATHS.INVENTORY) && !currentRoute.includes(ACCOUNT_PATHS.ON_FARM);

  const isOnFarmInventoryActive = () =>
    currentRoute.includes(ACCOUNT_PATHS.ON_FARM) && currentRoute.includes(ON_FARM_PATHS.INVENTORY);

  const closeSideBar = () => {
    setOpen(false);
    setOpenNavBar(false);
  };

  return (
    <div>
      <button type="button" className={activeLinkClass()} onClick={() => setShowInventoryOptions(!showInventoryOptions)}>
        <InventorySVG />
        {NAVIGATION_LINK_CONSTANTS.INVENTORY}
        <DropDownSVG reversed={showInventoryOptions} />
      </button>
      {showInventoryOptions && (
        <div>
          <Link
            className={isRsgInventoryActive() ? 'nav-sub-link active' : 'nav-sub-link'}
            to={ACCOUNT_PATHS.INVENTORY}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.RSG_INVENTORY}
          </Link>
          {REACT_APP_ON_FARM_ENABLED && (
            <>
              <button
                type="button"
                className={showOnFarmOptions ? 'nav-sub-link active' : 'nav-sub-link'}
                onClick={() => setShowOnFarmOptions(!showOnFarmOptions)}>
                {NAVIGATION_LINK_CONSTANTS.ON_FARM}
                <DropDownSVG reversed={showOnFarmOptions} />
              </button>
              {showOnFarmOptions && (
                <div>
                  <Link
                    className={isOnFarmInventoryActive() ? 'nav-sub-link active' : 'nav-sub-link'}
                    to={ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.INVENTORY}
                    onClick={closeSideBar}>
                    {NAVIGATION_LINK_CONSTANTS.ON_FARM_INVENTORY}
                  </Link>
                  {canTransact ? (
                    <Link
                      className={activeSubLinkClass(ON_FARM_PATHS.DEPOSIT)}
                      to={ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.DEPOSIT}
                      onClick={closeSideBar}>
                      {NAVIGATION_LINK_CONSTANTS.DEPOSIT}
                    </Link>
                  ) : (
                    <span className="nav-sub-link disabled" aria-disabled="true">
                      {NAVIGATION_LINK_CONSTANTS.DEPOSIT}
                    </span>
                  )}
                  {canTransact ? (
                    <Link
                      className={activeSubLinkClass(ON_FARM_PATHS.MOVE)}
                      to={ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.MOVE}
                      onClick={closeSideBar}>
                      {NAVIGATION_LINK_CONSTANTS.MOVE}
                    </Link>
                  ) : (
                    <span className="nav-sub-link disabled" aria-disabled="true">
                      {NAVIGATION_LINK_CONSTANTS.MOVE}
                    </span>
                  )}
                  <Link
                    className={activeSubLinkClass(ON_FARM_PATHS.CANISTER_CONTENTS)}
                    to={ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.CANISTER_CONTENTS}
                    onClick={closeSideBar}>
                    {PAGE_HEADER_CONSTANTS.CANISTER_CONTENTS}
                  </Link>
                  <Link
                    className={activeSubLinkClass(ON_FARM_PATHS.LOCATION_MANAGEMENT)}
                    to={ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.LOCATION_MANAGEMENT}
                    onClick={closeSideBar}>
                    {NAVIGATION_LINK_CONSTANTS.LOCATION_MANAGEMENT}
                  </Link>
                  <Link
                    className={activeSubLinkClass(ON_FARM_PATHS.SETTINGS)}
                    to={ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.SETTINGS}
                    onClick={closeSideBar}>
                    {NAVIGATION_LINK_CONSTANTS.SETTINGS}
                  </Link>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default InventoryLinks;
